import { CardEventGroup } from '../events/types';

export const enum EventgroupActiontypes {
  FETCH_REQUEST = '[eventgroup]FETCH_REQUEST',
  FETCH_SUCCESS = '[eventgroup]FETCH_SUCCESS',
  FETCH_ERROR = '[eventgroup]FETCH_ERROR'
}

export interface EventgroupState {
  readonly loading: boolean;
  readonly data: CardEventGroup[];
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/eventgroups/types.ts